import { Component, OnInit } from "@angular/core";
import { ReprocessingService } from "../../service/table/reprocessing.services";
import { ReprocessingTableComponent } from "../../components/table/reprocessing-table/reprocessing-table/reprocessing-table.component";

@Component({
  selector: "app-reprocessing",
  templateUrl: "./reprocessing.component.html",
  standalone: true,
  imports: [ReprocessingTableComponent],
  styleUrls: ["./reprocessing.component.scss"],
})
export class ReprocessingComponent implements OnInit {
  reprocessingService: ReprocessingService;

  constructor(private service: ReprocessingService) {
    this.reprocessingService = service;
  }

  ngOnInit() {}
}
